export const personnelFeatureKey = ['personnel'] as const;
